import styled, { css } from 'styled-components';

import { KebabMenu } from '@r1-frontend/ui-react/components/KebabMenu';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Svg from '@r1-frontend/ui-react/components/svg/Svg';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import { textOverflowLineClamp } from '@r1-frontend/ui-react/tokens/others/textOverflowLineClamp';

const Local_KebabHover = '#EFF3F7';

export const Wrapper = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    width: 352px;
    height: 352px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};
    user-select: none;

    @media (max-width: ${wideBreakpoints.tablet}) {
        border-radius: ${BorderRadius.InnerBlockRadius};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        max-width: 352px;
        border-radius: ${BorderRadius.InnerBlockRadius};
    }
`;

export const ImageBlock = styled.div<{ bgImage?: string }>`
    position: relative;
    flex: 0 0 160px;
    width: 100%;
    height: 160px;
    border-radius: ${BorderRadius.OuterBlockRadius} ${BorderRadius.OuterBlockRadius} 0 0;
    @media (max-width: ${wideBreakpoints.mobile}) {
       border-radius: ${BorderRadius.InnerBlockRadius} ${BorderRadius.InnerBlockRadius} 0 0;
    }
    overflow: hidden;
    ${p => p.bgImage && css`
        background-image: url(${p.bgImage});
        background-size: cover;
    `}

    picture {
        width: 100%;
        height: 100%;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        border-radius: ${BorderRadius.InnerBlockRadius} ${BorderRadius.InnerBlockRadius} 0 0;
    }
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-position: center;
    object-fit: cover;
`;

export const HeaderBlock = styled.div`
    flex-direction: column;
    padding: 32px 24px 8px;
`;

export const ContentBlock = styled.div`
    flex: 1 1 auto;
    flex-direction: column;
    flex-wrap: nowrap;
    row-gap: 4px;
    padding: 16px 24px 24px;
`;

export const PeriodData = styled.p`
    ${FONTS.MediumXS};
    color: ${COLORS.TextInfo};
`;

export const Name = styled.h4<{ maxRow?: number }>`
    ${FONTS.H4};
    ${p => p.maxRow ? textOverflowLineClamp(p.maxRow) : ''};
`;

export const Description = styled.div<{ maxRow?: number }>`
    ${FONTS.XS};
    color: ${COLORS.TextSecondary};
    ${p => p.maxRow ? textOverflowLineClamp(p.maxRow) : ''};
`;

export const Info = styled.div`
    ${FONTS.XS};
    color: ${COLORS.TextInfo};
`;

export const FooterBlock = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: flex-end;
    margin-top: auto;
    min-height: 36px;
`;

export const PriceWrap = styled.div`
    flex-direction: column;
    margin-right: auto;
`;

export const InfoPaymentWrap = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 6px;

    ${Svg} {
        margin-top: 2.5px;
        cursor: pointer;
    }
`;

export const ButtonGroup = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 8px;
    width: 100%;

    button {
        width: 100%;
    }
`;

export const PriceInfo = styled.div`
    ${FONTS.XXS};
    color: ${COLORS.TextSecondary};
`;

export const Price = styled.div`
    ${FONTS.H5};
    color: ${COLORS.TextSecondary};
    margin-right: auto;
    overflow: hidden;
    white-space: nowrap;
`;

export const Kebab = styled(KebabMenu)`
    flex: 0 0 36px;
    height: 36px;
    margin-left: 8px;
    border-radius: 50%;
    background-color: ${COLORS.ButtonSecondary};

    @media (hover: hover) {
        &:hover {
            background-color: ${Local_KebabHover};
        }
    }

    div[data-name='popup-menu'] {
        top: 48px;
        right: -24px;
        z-index: 100;
    }

    div[data-name='menu-row'] {
        @media (hover: hover) {
            &:hover {
                background-color: ${COLORS.BgLight};
            }
        }
    }
`;
